import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import ContentContainer from '~/components/contentContainer/contentContainer';
import CustomerCreate from '~/containers/customerCreate/customerCreate';

export class CustomerCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/customers`}>
        <Button color="secondary" onClick={this.onCancelClick}>
          Cancel
        </Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar
          back="/customers"
          icon="users"
          backText="Customers"
          title="Create a new customer"
          button={cancelButton}
        />
        <section>
          <div className="pa3">
            <ContentContainer>
              <CustomerCreate />
            </ContentContainer>
          </div>
        </section>
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(CustomerCreatePage));



// WEBPACK FOOTER //
// ./src/pages/customerCreate/customerCreate.jsx